/** Users · parse pasted "Name <email>" / "Name, email" lines into candidate contacts.
 *  Shared by NewRequest (Mode B) and the funnel's invite-more panel. */
import type { CandidateContact } from "@talenthop/shared";

export function parseCandidateLines(text: string): {
  candidates: CandidateContact[];
  invalid: string[];
} {
  const candidates: CandidateContact[] = [];
  const invalid: string[] = [];
  for (const raw of text.split("\n")) {
    const line = raw.trim();
    if (!line) continue;
    const m = /^(.*?)[<,]\s*([^\s<>,]+@[^\s<>,]+?)>?\s*$/.exec(line);
    if (m && m[1] && m[2] && m[1].trim().length > 0) {
      candidates.push({ name: m[1].trim(), email: m[2].trim() });
    } else {
      invalid.push(line);
    }
  }
  return { candidates, invalid };
}
